export const projects = [
  {
    title: "NeuroSharp",
    description: "neuroSharpDescriptionShort",
    image: "/projects/neurosharp.webp",
    route: "/portfolio/neurosharp",
  },
  {
    title: "ABB",
    description: "abbDescriptionShort",
    image: "/projects/abb.webp",
    route: "/portfolio/abb",
  },  
  /*{
    title: "CoolGreen",
    description: "coolGreenDescriptionShort",
    image: "/projects/coolgreen.webp",
    route: "/portfolio/coolgreen",
  },*/
  {
    title: "IMCORP",
    description: "imcorpDescriptionShort",
    image: "/projects/imcorp.webp",
    route: "/portfolio/imcorp",
  },
  {
    title: "upworkTitle",
    description: "upworkDescriptionShort",
    image: "/projects/upwork.webp",
    route: "/portfolio/upwork",
  },
  {
    title: "ADME",
    description: "admeDescriptionShort",
    image: "/projects/adme.webp",
    route: "/portfolio/adme",
  },  
  {
    title: "UTE",
    description: "uteDescriptionShort",
    image: "/projects/ute.webp",
    route: "/portfolio/ute",
  },

  
];

export const reviews = [
  {
    jobTitle: "Seeking Embedded Systems Developer for nRF52840 Project",
    clientName: "Steve",
    flag: "us",
    text: "Yuri was an absolute pleasure to deal with. Very responsive and really puts his heart into the project. He really goes above and beyond the normal call of duty. Looking forward to working with him again the next time I have a firmware project to build."
  },
  {
    jobTitle: "Firmware for BLE/Zigbee device",
    clientName: "Hamid",
    flag: "nl",
    text: "If you are looking for a BLE and Zigbee pro, then Yuri is your guy. He is also super friendly and a good communicator."
  },
  {
    jobTitle: "Arduino Software Programming Help Needed",
    clientName: "Craig",
    flag: "us",
    text: "I've been using Upwork for a number of years, and Yuri is definitively the best freelancer I've hired to date. He consistently went above and beyond my expectation level to make sure my project was going to be a success. His professionalism, ability to articulate himself, and solve problems was truly exceptional. If I could give 6 stars in all categories I would."
  },  
  {
    jobTitle: "Part time: c/c++ and node.js coder needed for embedded IoT solution",
    clientName: "Aleksi",
    flag: "ee",
    text: "Excellent worker, good communication skills and completed the job in time. Yuri delivered good work on this C/C++, node.js and IoT development project and I enjoyed working with him. His communication was top-notch, he met all deadlines, and his skills were reasonably strong. I enjoyed working with Yuri and will likely have additional jobs for him in the future."
  }, 
  {
    jobTitle: "Wireless UART using nrf52840",
    clientName: "Ayman",
    flag: "tr",
    text: "Yuri fulfilled this project requirement to the best of available documentation. What I like the most about Yuri is his sense of ownership and responsibility of his work and trying to make sure to complete the job in timely manner. Thanks Yuri. He is knowledgeable with Nordic chipset and development environment. I would highly recommend Yuri and willing to work with him again once another opportunity come up."
  },
  {
    jobTitle: "Help debug SPI and understand VHDL code",
    clientName: "Isadora",
    flag: "br",
    text: "Yuri is a great worker! I'm 100% satisfied with his work! Very trustworthy!"
  },  
  {
    jobTitle: "Update ESPHome Custom Component TCP Serial",
    clientName: "Byron",
    flag: "us",
    text: "Yuri completed this project quickly. He was very transparent and communication through out the project was great. I'd highly recommend him and will work with him again in the future if the need arises. Very satisfied with the outcome of the project."
  },
  {
    jobTitle: "Urgent help needed to sort out a few LaTex issues using Overleaf.",
    clientName: "Peren",
    flag: "ae",
    text: "Yuri was a rare find! Thanks a lot for your cooperation, flexibility, innovative solutions and understanding"
  },
  {
    jobTitle: "Academic Mathematics Report writing in Latex.",
    clientName: "Nick",
    flag: "ca",
    text: "Down to earth, very humble and professional. Always responded on time and got the job done perfectly. Overall very satisfied."
    },  

];